const PLAN_STATE_PREFIX = 'ftplan:';

export const FREE_TRIAL_SUBSCRIPTION_PATH = '/subscription';

export function getOfficeOrdersUrl() {
  const main = String(process.env.NEXT_PUBLIC_MAIN_APP_URL || '').replace(/\/$/, '');
  return main ? `${main}/orders` : '';
}

/**
 * Post-signup destination. A `plan` query on `/auth/free-trial` sends the user
 * to the portal subscription page; otherwise the portal root, which redirects
 * to Office `/orders`.
 */
export function freeTrialAuthReturnTo(plan) {
  if (typeof plan !== 'string') {
    return '/';
  }
  const params = new URLSearchParams();
  params.set('plan', plan);
  return `${FREE_TRIAL_SUBSCRIPTION_PATH}?${params.toString()}`;
}

/** Round-trip the requested plan through Auth0 `state` without changing the callback URL. */
export function encodeFreeTrialPlanState(plan) {
  if (typeof plan !== 'string') {
    return null;
  }
  return `${PLAN_STATE_PREFIX}${encodeURIComponent(plan)}`;
}

export function decodeFreeTrialPlanState(state) {
  if (typeof state !== 'string' || !state.startsWith(PLAN_STATE_PREFIX)) {
    return null;
  }
  const encoded = state.slice(PLAN_STATE_PREFIX.length);
  try {
    return decodeURIComponent(encoded);
  } catch {
    return encoded;
  }
}

export function resolveFreeTrialPlan({ plan, state } = {}) {
  if (typeof plan === 'string') {
    return plan;
  }
  return decodeFreeTrialPlanState(state);
}

export function buildWelcomeUrl({
  companyName,
  sessionReady,
  metadataSynced,
  ssoFailed,
  plan,
} = {}) {
  const params = new URLSearchParams();
  if (companyName) params.set('company', companyName);
  if (sessionReady === false) params.set('session', '0');
  if (metadataSynced === false) params.set('metadata', '0');
  if (ssoFailed) params.set('sso', '0');
  if (typeof plan === 'string') params.set('plan', plan);
  const qs = params.toString();
  return `/auth/free-trial/welcome${qs ? `?${qs}` : ''}`;
}
